/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Queues_Custom_Property5Inputs */

const en_tables_queues_custom_property5 = /** @type {(inputs: Tables_Queues_Custom_Property5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property5`)
};

const de_tables_queues_custom_property5 = /** @type {(inputs: Tables_Queues_Custom_Property5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property5`)
};

/**
* | output |
* | --- |
* | "Property5" |
*
* @param {Tables_Queues_Custom_Property5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_queues_custom_property5 = /** @type {((inputs?: Tables_Queues_Custom_Property5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Queues_Custom_Property5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_queues_custom_property5(inputs)
	return de_tables_queues_custom_property5(inputs)
});